export const can_show_ticking_clock = (user = window.gon.current_user) => {
  if (!user) return false
  if (!time_since_trial_started(user)) return false
  if (!["user", "trial"].includes(user.role)) return false
  // within first 24h after registration
  return time_since_trial_started(user) < 24 * 60 * 60 * 1000
}

export const trial_time_left = (user = window.gon.current_user) => {
  if (!time_since_trial_started(user)) return false
  return 65 * 60 * 1000 - time_since_trial_started(user)
}

const time_since_trial_started = (user = window.gon.current_user) =>
  Date.now() - user.trial_started_at * 1000
